import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ToolsService {

    months = [
        { id: 0, name: 'Jan' },
        { id: 1, name: 'Feb' },
        { id: 2, name: 'Mar' },
        { id: 3, name: 'Apr' },
        { id: 4, name: 'May' },
        { id: 5, name: 'Jun' },
        { id: 6, name: 'Jul' },
        { id: 7, name: 'Aug' },
        { id: 8, name: 'Sep' },
        { id: 9, name: 'Oct' },
        { id: 10, name: 'Nov' },
        { id: 11, name: 'Dec' }
    ];
    years = [];

    constructor() {
        for (let i = 2019; i <= new Date().getFullYear(); i++) {
            this.years.push(i);
        }
    }

    newUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }


    addDaysToDate(theDate, days, excludeWeekends) {
        let endDate = new Date(), count = 0;
        while (count < days) {
            endDate = new Date(theDate.setDate(theDate.getDate() + 1));
            if (excludeWeekends) {
                if (endDate.getDay() !== 0 && endDate.getDay() !== 6) {
                    count++;
                }
            } else {
                count++;
            }
        }
        return endDate;
    }

    removeDaysFromDate(endDate, excludeWeekends) {
        let dateToday = new Date(), daysExcluded = 0;
        const days = this.datediff(dateToday, endDate);
        let x = 0;

        while (x <= (days + 2)) {
            endDate = new Date(endDate.setDate(endDate.getDate() - 1));

            if (excludeWeekends) {
                if (endDate.getDay() === 0 || endDate.getDay() === 6) {
                    daysExcluded++;
                }
            }
            x++;
        }
        return ((days + 2) - daysExcluded);
    }

    weekendDaysBetweenDates(firstDate, secondDate) {
        let weekendDays = 0;

        while (firstDate <= secondDate) {
            const currDate = new Date(firstDate.setDate(firstDate.getDate() + 1));
            if (firstDate.getDay() === 0 || firstDate.getDay() === 6) {
                weekendDays++;
            }
        }
        return weekendDays;
    }

    parseDate(str) {
        var mdy = str.split('/');
        return new Date(mdy[2], mdy[0] - 1, mdy[1]);
    }

    datediff(first, second) {
        // Take the difference between the dates and divide by milliseconds per day.
        // Round to nearest whole number to deal with DST.
        return Math.round((second - first) / (1000 * 60 * 60 * 24));
    }

    isFileAnImage(fileName: string): boolean {
        const split = fileName.split('.');
        const fileExt = split[split.length - 1];
        if (['ai', 'bmp', 'gif', 'jpeg', 'jpg', 'png', 'webp', 'svg', 'tif', 'tiff'].indexOf(fileExt) !== -1) {
            return true;
        }

        return false;
    }

    getFileType(fileName: string): string {
        const split = fileName.split('.');
        const fileExt = split[split.length - 1];
        if (['ai', 'bmp', 'gif', 'jpeg', 'jpg', 'png', 'webp', 'svg', 'tif', 'tiff'].indexOf(fileExt) !== -1) {
            return 'Image file';
        }

        if (['aif', 'cda', 'mid', 'midi', 'mp3', 'mpa', 'ogg', 'wav', 'wma', 'wpl'].indexOf(fileExt) !== -1) {
            return 'Audio file';
        }

        if (['7z', 'arj', 'deb', 'pkg', 'rar', 'rpm', 'tar', 'gz', 'zip', 'z'].indexOf(fileExt) !== -1) {
            return 'Archive file';
        }

        if (['email', 'eml', 'emlx', 'msg', 'oft', 'ost', 'pst', 'vcf'].indexOf(fileExt) !== -1) {
            return 'Email file';
        }

        if (['fnt', 'fon', 'otf', 'ttf'].indexOf(fileExt) !== -1) {
            return 'Font file';
        }

        if (['htm', 'html', 'xhtml'].indexOf(fileExt) !== -1) {
            return 'Webpage file';
        }

        if (['key', 'odp', 'pps', 'ppt', 'pptx'].indexOf(fileExt) !== -1) {
            return 'Presentation file';
        }

        if (['ods', 'xls', 'xlsm', 'xlsx'].indexOf(fileExt) !== -1) {
            return 'Spreadsheet file';
        }

        if (['3g2', '3gp', 'avi', 'flv', 'h264', 'm4v', 'mkv', 'mov', 'mp4', 'mpg', 'mpeg', 'rm', 'swf', 'vob', 'webm', 'wmv'].indexOf(fileExt) !== -1) {
            return 'Video file';
        }

        if (['doc', 'docx', 'odt', 'pdf', 'rtf', 'tex', 'txt', 'wpd'].indexOf(fileExt) !== -1) {
            return 'Word Document file';
        }

        return 'Unknown File';
    }

    getDiscountedValue(originalValue, percentage) {
        return Math.round((+originalValue - (+originalValue * (+percentage / 100))) * 100) / 100
    }
    getPercentageOf(originalValue, percentage) {
        const resultInCents = (originalValue / 100) * +percentage;
        const roundedResultInCents = Math.round(resultInCents * 100) / 100; // Round to 2 decimal places
        const roundedResultAsNumber = parseFloat(roundedResultInCents.toFixed(2));

        return roundedResultAsNumber;
    }
}
